import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-submit-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './submit-button.component.html',
  styleUrl: './submit-button.component.scss',
})
export class SubmitButtonComponent {
  @Input() isLoading = false;
  @Input() isDisabled = false;
  @Input() buttonText = 'DALEJ';
  @Output() clickEvent = new EventEmitter<void>();

  handleClick() {
    if (!this.isLoading && !this.isDisabled) {
      this.clickEvent.emit();
    }
  }
}
